import 'substance/dist/substance.css'
import 'substance/dist/substance-reset.css'
import 'substance/dist/substance-pagestyle.css'

import 'font-awesome/css/font-awesome.css'

import ArticleEditor from './ArticleEditor'

export default ArticleEditor



// WEBPACK FOOTER //
// ./src/index.js